import React, { forwardRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Divider,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  FormHelperText,
  Alert,
  Modal,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  useTheme,
  Badge,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { ListItemButton } from "@mui/material";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import MaterialTable from "./components/MaterialTable";
import SearchIcon from "@material-ui/icons/Search";
import { IconButton, Tooltip } from "@material-ui/core";
import GroupIcon from "@mui/icons-material/Group";
import {
  AddBox,
  ArrowDownward,
  ChevronLeft,
  ChevronRight,
  Clear,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
  Delete,
} from "@material-ui/icons";
import ApiService from "./ApiService";
import RegularTooltip from "./components/Custom/Tooltip/Tooltip";
import Button from "./components/Custom/Button/Button";
import PersonIcon from "@mui/icons-material/Person";

const MenuManagement = () => {
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState("");
  const [failed, setFailed] = useState(false);
  const [success, setSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [failed2, setFailed2] = useState(false);
  const [success2, setSuccess2] = useState(false);
  const [responseMessage2, setResponseMessage2] = useState(null);
  const [data, setData] = useState([]);
  const [showTableData, setShowTableData] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [menus, setMenus] = useState([]);
  const [parentId, setParentId] = useState(null);
  const [features, setFeatures] = useState([]);
  const [formData, setFormData] = useState({
    menu: "",
    menuName: "",
    tooltip: "",
    iconName: "",
    link: "",
    feature: "",
    sequence: "",
  });

  const [formErrors, setFormErrors] = useState({
    menuName: "",
    tooltip: "",
    iconName: "",
    link: "",
    feature: "",
    sequence: "",
  });

  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [rowToDelete, setRowToDelete] = useState({});
  const [updated, setUpdated] = useState(null);
  const [openUserAccessDialog, setOpenUserAccessDialog] = useState(false);
  const [menuUsers, setMenuUsers] = useState([]);
  const [selectedMenuId, setSelectedMenuId] = useState(null);
  const [loadingMenuUsers, setLoadingMenuUsers] = useState(false);
  const [menuID, setMenuID] = useState(null);

  useEffect(() => {
    if (success || failed || success2 || failed2) {
      const timer = setTimeout(() => {
        setSuccess(false);
        setFailed(false);
        setResponseMessage(null);
        setSuccess2(false);
        setFailed2(false);
        setResponseMessage2(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success, failed, success2, failed2]);

  const handleUserTypeChange = (event) => {
    setUserType(event.target.value);
  };

  const fetchMenus = () => {
    ApiService.fetchMenusByModuleType(userType).then((response) => {
      if (response.data.status === "OK") {
        setData(response.data.responseObject);
        setMenus(response.data.responseObject);
      } else {
        setMenus([]);
      }
    });
  };
  const getFeatures = () => {
    ApiService.getFeatures(userType).then((response) => {
      if (response.data.status === "OK") {
        setFeatures(response.data.responseObject);
      } else {
        setFeatures([]);
      }
    });
  };

  const handleSearch = () => {
    if (userType === "") {
      setFailed(true);
      setSuccess(false);
      setResponseMessage("Please select a user");
      return;
    }
    setLoading(true);
    ApiService.fetchMenusByModuleType(userType)
      .then((response) => {
        if (response.data.status === "OK") {
          setShowTableData(true);
          setSuccess(true);
          setFailed(false);
          setResponseMessage("Data Fetched Successfully");
          setData(response.data.responseObject);
        } else {
          setShowTableData(false);
          setSuccess(false);
          setFailed(true);
          setResponseMessage(response.data.responseMessage);
        }
      })
      .catch((error) => {
        setShowTableData(false);
        setSuccess(false);
        setFailed(true);
        setResponseMessage("Failed to fetch Data");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleAddNewMenu = () => {
    setIsEditMode(false);
    setOpenDialog(true);
    fetchMenus();
    getFeatures();
    setFormData({
      menu: "",
      menuName: "",
      tooltip: "",
      iconName: "",
      link: "",
      feature: "",
      sequence: "",
    });
    setFormErrors({
      menuName: "",
      tooltip: "",
      iconName: "",
      link: "",
      feature: "",
      sequence: "",
    });
  };

  const fetchMenuById = (menuId) => {
    ApiService.fetchMenuById(menuId).then((response) => {
      if (response.data.status === "OK") {
        setUpdated(
          response.data.responseObject.updated
            ? response.data.responseObject.updated
            : null
        );
      } else {
        setUpdated(null);
      }
    });
  };

  const handleEditMenu = (rowData) => {
    setIsEditMode(true);
    setSelectedRow(rowData);
    getFeatures();
    fetchMenus();
    fetchMenuById(rowData.id);
    setParentId(rowData.parentId);
    setFormData({
      menu: rowData.id,
      menuName: rowData.text,
      tooltip: rowData.tooltip,
      iconName: rowData.icon,
      link: rowData.link,
      feature: rowData.feature.id,
      sequence: rowData.sequence,
    });
    setFormErrors({
      menuName: "",
      tooltip: "",
      iconName: "",
      link: "",
      feature: "",
      sequence: "",
    });
    setOpenDialog(true);
  };

  const handleDeleteMenu = (rowData) => {
    setRowToDelete(rowData);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleCloseUserAccessDialog = () => {
    setLoadingMenuUsers(true);
    setOpenUserAccessDialog(false);
    setMenuUsers([]);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFormData({
      menu: "",
      menuName: "",
      tooltip: "",
      iconName: "",
      link: "",
      feature: "",
      sequence: "",
    });
    setFormErrors({
      menuName: "",
      tooltip: "",
      iconName: "",
      link: "",
      feature: "",
      sequence: "",
    });
  };

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!formData.menuName) {
      errors.menuName = "*Menu Name is required";
      isValid = false;
    }

    if (!formData.tooltip) {
      errors.tooltip = "*Tooltip is required";
      isValid = false;
    }

    if (!formData.iconName) {
      errors.iconName = "*Icon Name is required";
      isValid = false;
    }

    if (!formData.link) {
      errors.link = "*Link is required";
      isValid = false;
    } else {
      const urlRegex = /^\/(#[a-zA-Z0-9-_\/]*)?([a-zA-Z0-9-_\/]*)$/;
      if (!urlRegex.test(formData.link)) {
        errors.link =
          "*Please enter a valid Link, starting with '/' or '/#' (e.g., /settings or /#profile)";
        isValid = false;
      }
    }

    if (!formData.feature) {
      errors.feature = "*Feature is required";
      isValid = false;
    }
    if (!formData.sequence) {
      errors.sequence = "*Sequence is required";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleCreateMenu = () => {
    if (validateForm()) {
      ApiService.addNewMenu(
        formData.menu,
        formData.menuName,
        formData.tooltip,
        formData.iconName,
        formData.link,
        formData.feature,
        formData.sequence
      )
        .then((response) => {
          if (response.data.status === "OK") {
            setSuccess2(true);
            setFailed2(false);
            setResponseMessage2("Menu Created Successfully");
            fetchMenus();
          } else {
            setSuccess2(false);
            setFailed2(true);
            setResponseMessage2(response.data.responseMessage);
          }
        })
        .catch((error) => {
          setSuccess2(false);
          setFailed2(true);
          setResponseMessage2("Error in Creating Menu");
        });
      setTimeout(() => {
        handleCloseDialog();
      }, 3000);
    }
  };

  const handleUpdateMenu = () => {
    if (validateForm()) {
      ApiService.updateMenu(
        parentId,
        formData.menu,
        formData.menuName,
        formData.tooltip,
        formData.iconName,
        formData.link,
        formData.feature,
        formData.sequence,
        updated
      )
        .then((response) => {
          if (response.data.status === "OK") {
            setSuccess2(true);
            setFailed2(false);
            setResponseMessage2("Menu Updated Successfully");
            fetchMenus();
          } else {
            setSuccess2(false);
            setFailed2(true);
            setResponseMessage2(response.data.responseMessage);
          }
        })
        .catch((error) => {
          setSuccess2(false);
          setFailed2(true);
          setResponseMessage2("Error in Updating Menu");
        });

      setTimeout(() => {
        handleCloseDialog();
      }, 3000);
    }
  };

  const handleConfirmDelete = () => {
    ApiService.deleteMenu(rowToDelete.id)
      .then((response) => {
        if (response.data.status === "OK") {
          setSuccess2(true);
          setFailed2(false);
          setResponseMessage2("Menu Deleted Successfully");
          fetchMenus();
        } else {
          setSuccess2(false);
          setFailed2(true);
          setResponseMessage2(response.data.responseMessage);
        }
      })
      .catch((error) => {
        setSuccess2(false);
        setFailed2(true);
        setResponseMessage2("Error in Deleting Menu");
      });
    setTimeout(() => {
      handleCloseDeleteDialog();
    }, 3000);
  };

  const handleUserAccessClick = (rowData) => {
    setSelectedMenuId(rowData.id);
    setOpenUserAccessDialog(true);
    fetchMenuUsers(rowData.id);
    setMenuID(rowData.id);
  };

  const fetchMenuUsers = (menuId) => {
    setLoadingMenuUsers(true);
    ApiService.menuAccessDetails(menuId)
      .then((response) => {
        if (response.data.status === "OK") {
          setMenuUsers(response.data.responseObject);
        } else {
          setMenuUsers([]);
          setFailed2(true);
          setResponseMessage2(response.data.responseMessage);
        }
      })
      .catch((error) => {
        setMenuUsers([]);
        setFailed2(true);
        setResponseMessage2("Error in fetching user");
      })
      .finally(() => {
        setLoadingMenuUsers(false);
      });
  };

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
    setFormErrors({
      ...formErrors,
      [field]: "",
    });
  };

  const DeleteUserAccess = (userId) => {
    ApiService.removeUserMenuAccess(userId, menuID)
      .then((res) => {
        if (res.data.status === "OK") {
          setSuccess2(true);
          setFailed2(false);
          setResponseMessage2(res.data.responseMessage);
          fetchMenuUsers(menuID);
          fetchMenus();
        } else {
          setSuccess2(false);
          setFailed2(true);
          setResponseMessage2(res.data.responseMessage);
        }
      })
      .catch((error) => {
        setSuccess2(false);
        setFailed2(true);
        setResponseMessage2("Error in Deleting User");
      });
  };

  const columns = [
    {
      title: "Menu ID",
      field: "id",
      render: (rowData) => (
        <RegularTooltip title={rowData.id} copy={true}>
          {" "}
          <InfoOutlinedIcon />{" "}
        </RegularTooltip>
      ),
    },
    { title: "Menu Name", field: "text" },

    { title: "Link", field: "link" },
    { title: "Feature Name", field: "feature.feature" },
    { title: "Sequence", field: "sequence" },

    {
      title: "Actions",
      render: (rowData) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="Edit Menu">
            <IconButton color="primary" onClick={() => handleEditMenu(rowData)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Menu">
            <IconButton
              color="primary"
              onClick={() => handleDeleteMenu(rowData)}
            >
              <Delete />
            </IconButton>
          </Tooltip>

          <Tooltip title="User Access">
            <IconButton
              color="primary"
              onClick={() => handleUserAccessClick(rowData)}
            >
              <Box sx={{ display: "flex", alignItems: "left", gap: 0.8 }}>
                {" "}
                <GroupIcon />
                <Badge badgeContent={rowData.count} color="primary" max={99} />
              </Box>
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),

    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),

    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const loadingModalStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const theme = useTheme();

  return (
    <Box sx={{ p: 3, bgcolor: "white", color: "black" }}>
      <Modal open={loading} style={loadingModalStyle}>
        <Box>
          <CircularProgress color="primary" />
        </Box>
      </Modal>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        Menu Management
      </Typography>
      {failed && (
        <Alert severity="error" elevation={0}>
          {" "}
          {responseMessage}
        </Alert>
      )}
      {success && (
        <Alert severity="success" elevation={0}>
          {" "}
          {responseMessage}
        </Alert>
      )}
      <Divider light />
      <Box sx={{ display: "flex", gap: 2, mb: 3, mt: 3, alignItems: "center" }}>
        <FormControl
          sx={{
            width: { xs: "100%", sm: 200 },
            position: "relative",
          }}
        >
          <InputLabel
            id="demo-simple-select-label"
            sx={{
              fontSize: 14,
              color: "#666",
              transform: "translate(14px, 12px) scale(1)",
              transition: "all 0.2s ease-in-out",
              "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -5px) scale(0.85)",
              },
            }}
          >
            System
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={userType}
            label="System"
            onChange={handleUserTypeChange}
            sx={{
              height: 40,
              borderRadius: 2,
              borderColor: "#ccc",
              fontSize: 14,
              backgroundColor: "#fff",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              "& .MuiSelect-select": {
                padding: "10px",
                paddingTop: "14px",
                "&:focus": {
                  backgroundColor: "#f7f7f7",
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#ccc",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: 1,
                },
              },
            }}
          >
            <MenuItem
              value="ADMINBO"
              sx={{
                fontSize: 14,
                py: 1,
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              Admin
            </MenuItem>
            <MenuItem
              value="MERCHANTBO"
              sx={{
                fontSize: 14,
                py: 1,
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              Merchant
            </MenuItem>
            <MenuItem
              value="AGENTBO"
              sx={{
                fontSize: 14,
                py: 1,
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              Agent
            </MenuItem>
          </Select>
        </FormControl>

        <Button
          variant="contained"
          onClick={handleSearch}
          color="primary"
          size="large"
          startIcon={<SearchIcon sx={{ fontSize: 20 }} />}
          sx={{
            height: 35,
            fontSize: 14,
            textTransform: "capitalize",
            borderRadius: 1,
          }}
        >
          Search
        </Button>
      </Box>

      <>
        <MaterialTable
          icons={tableIcons}
          columns={columns}
          data={data}
          title=""
          components={{
            Toolbar: (props) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "10px 10px 0 10px",
                }}
              >
                {showTableData ? (
                  <Button
                    variant="contained"
                    onClick={handleAddNewMenu}
                    startIcon={<AddBox />}
                    color="primary"
                    size="small"
                  >
                    Add New Menu
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    startIcon={<AddBox />}
                    color="primary"
                    size="small"
                    disabled
                  >
                    Add New Menu
                  </Button>
                )}
              </div>
            ),
          }}
          options={{
            search: false,
            exportButton: false,
            pageSize: 5,
            pageSizeOptions: [5, 10, 20],
            padding: "default",
            showEmptyDataSourceMessage: true,
            doubleHorizontalScroll: true,
            selection: false,
            actionsColumnIndex: -1,
            tableLayout: "auto",
            emptyRowsWhenPaging: false,
          }}
        />
      </>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #ccc",
            padding: "16px",
            fontSize: 18,
            fontWeight: 600,
            color: "#333",
          }}
        >
          {isEditMode ? <span>Edit Menu</span> : <span>Add Menu</span>}
          {failed2 && (
            <Alert severity="error" elevation={0}>
              {" "}
              {responseMessage2}
            </Alert>
          )}
          {success2 && (
            <Alert severity="success" elevation={0}>
              {" "}
              {responseMessage2}
            </Alert>
          )}
        </DialogTitle>
        <DialogContent
          sx={{
            mt: "24px",
            mb: "24px",
            "&::-webkit-scrollbar": {
              width: "8px",
              backgroundColor: "#f0f0f0",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#aaa",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#777",
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <FormControl fullWidth size="small" margin="dense">
              <InputLabel
                id="demo-simple-select-label"
                sx={{ fontSize: 14, color: "#333" }}
              >
                Menu
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={formData.menu}
                onChange={handleInputChange("menu")}
                label="Menu"
                sx={{
                  height: 40,
                  borderRadius: 2,
                }}
              >
                {menus.map((menu, index) => (
                  <MenuItem
                    key={menu.id}
                    value={menu.id}
                    sx={{ fontSize: 14, py: 1 }}
                  >
                    {menu.text}
                  </MenuItem>
                ))}
                <MenuItem value=" " sx={{ fontSize: 14, py: 1 }}>
                  None
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              size="small"
              margin="dense"
              error={!!formErrors.menuName}
            >
              <TextField
                fullWidth
                size="small"
                label="Menu Name"
                value={formData.menuName}
                onChange={handleInputChange("menuName")}
                sx={{ fontSize: 14, height: 40, borderRadius: 2 }}
              />
              {formErrors.menuName && (
                <FormHelperText sx={{ mb: -1 }}>
                  {formErrors.menuName}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              size="small"
              margin="dense"
              error={!!formErrors.tooltip}
            >
              <TextField
                fullWidth
                size="small"
                label="Tooltip"
                value={formData.tooltip}
                onChange={handleInputChange("tooltip")}
                sx={{ fontSize: 14, height: 40, borderRadius: 2 }}
              />
              {formErrors.tooltip && (
                <FormHelperText sx={{ mb: -1 }}>
                  {formErrors.tooltip}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              size="small"
              margin="dense"
              error={!!formErrors.iconName}
            >
              <TextField
                fullWidth
                size="small"
                label="Icon Name"
                value={formData.iconName}
                onChange={handleInputChange("iconName")}
                sx={{ fontSize: 14, height: 40, borderRadius: 2 }}
              />
              {formErrors.iconName && (
                <FormHelperText sx={{ mb: -1 }}>
                  {formErrors.iconName}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              size="small"
              margin="dense"
              error={!!formErrors.link}
            >
              <TextField
                fullWidth
                size="small"
                label="Link"
                value={formData.link}
                onChange={handleInputChange("link")}
                sx={{ fontSize: 14, height: 40, borderRadius: 2 }}
              />
              {formErrors.link && (
                <FormHelperText sx={{ mb: -1 }}>
                  {formErrors.link}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              size="small"
              margin="dense"
              error={!!formErrors.feature}
            >
              <InputLabel sx={{ fontSize: 14, color: "#333" }}>
                Feature
              </InputLabel>
              <Select
                value={formData.feature}
                onChange={handleInputChange("feature")}
                label="Feature"
                sx={{
                  height: 40,
                  borderRadius: 2,
                  fontSize: 14,
                }}
              >
                {features.map((feature, index) => (
                  <MenuItem
                    key={feature.id}
                    value={feature.id}
                    sx={{ fontSize: 14, py: 1 }}
                  >
                    {feature.feature}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.feature && (
                <FormHelperText sx={{ mb: -1 }}>
                  {formErrors.feature}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              size="small"
              margin="dense"
              error={!!formErrors.sequence}
            >
              <TextField
                fullWidth
                size="small"
                label="Sequence"
                type="number"
                value={formData.sequence}
                onChange={handleInputChange("sequence")}
                sx={{ fontSize: 14, height: 40, borderRadius: 2 }}
              />
              {formErrors.sequence && (
                <FormHelperText sx={{ mb: -1 }}>
                  {formErrors.sequence}
                </FormHelperText>
              )}
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "16px", gap: 2 }}>
          {isEditMode ? (
            <Button
              variant="contained"
              onClick={handleUpdateMenu}
              color="primary"
              size="small"
              sx={{
                fontSize: 14,
                textTransform: "capitalize",
                height: 40,
                borderRadius: 1,
              }}
            >
              Update
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={handleCreateMenu}
              color="primary"
              size="small"
              sx={{
                fontSize: 14,
                textTransform: "capitalize",
                height: 40,
                borderRadius: 1,
              }}
            >
              Create
            </Button>
          )}
          <Button
            variant="contained"
            onClick={handleCloseDialog}
            color="primary"
            size="small"
            sx={{
              fontSize: 14,
              textTransform: "capitalize",
              height: 40,
              borderRadius: 1,
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        maxWidth="xs"
        fullWidth
      >
        {failed2 && (
          <Alert severity="error" elevation={0} sx={{ mt: 2 }}>
            {" "}
            {responseMessage2}
          </Alert>
        )}
        {success2 && (
          <Alert severity="success" elevation={0} sx={{ mt: 2 }}>
            {" "}
            {responseMessage2}
          </Alert>
        )}
        <DialogTitle
          sx={{
            borderBottom: "1px solid #ccc",
            padding: "16px",
            fontSize: 18,
            fontWeight: 600,
            color: "#333",
          }}
        >
          Delete Menu
        </DialogTitle>

        <DialogContent
          sx={{
            mt: "24px",
            mb: "24px",
            padding: "0 24px",
          }}
        >
          <Typography
            sx={{
              fontSize: 16,
              color: "#666",
              marginBottom: "24px",
            }}
          >
            Are you sure you want to delete "
            <strong>{rowToDelete.text + " " + "Menu"}</strong>
            "?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              variant="contained"
              onClick={handleConfirmDelete}
              size="small"
              sx={{
                fontSize: 14,
                textTransform: "capitalize",
                height: 40,
                borderRadius: 1,
                backgroundColor: "#e74c3c",
                "&:hover": {
                  backgroundColor: "#c0392b",
                },
              }}
            >
              Delete
            </Button>
            <Button
              variant="outlined"
              onClick={handleCloseDeleteDialog}
              size="small"
              sx={{
                fontSize: 14,
                textTransform: "capitalize",
                height: 40,
                borderRadius: 1,
                borderColor: "#337ab7",
                color: "#337ab7",
                "&:hover": {
                  borderColor: "#23527c",
                  color: "#23527c",
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openUserAccessDialog}
        onClose={handleCloseUserAccessDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #ccc",
            padding: "16px",
            fontSize: 18,
            fontWeight: 600,
            color: "#333",
          }}
        >
          Users with Access to Menu
          {failed2 && (
            <Alert severity="error" elevation={0}>
              {" "}
              {responseMessage2}
            </Alert>
          )}
          {success2 && (
            <Alert severity="success" elevation={0}>
              {" "}
              {responseMessage2}
            </Alert>
          )}
        </DialogTitle>
        <DialogContent
          sx={{
            mt: "24px",
            mb: "24px",
            "&::-webkit-scrollbar": {
              width: "8px",
              backgroundColor: "#f0f0f0",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#aaa",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#777",
            },
          }}
        >
          {loadingMenuUsers ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 100,
              }}
            >
              <CircularProgress color="primary" />
            </Box>
          ) : menuUsers && menuUsers.length > 0 ? (
            <List>
              {menuUsers.map((user) => (
                <ListItem
                  key={user.id}
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    marginBottom: "8px",
                    padding: "10px",
                    bgcolor: "#fff",
                  }}
                >
                  <ListItemButton
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: 0,

                      "&:hover": {},
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <ListItemAvatar>
                        <Avatar
                          sx={{
                            bgcolor: theme.palette.primary.main,
                          }}
                        >
                          <PersonIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={user.userName} />
                    </div>
                    <Tooltip title="Delete Access">
                      <IconButton
                        onClick={() => DeleteUserAccess(user.id)}
                        size="small"
                        color="primary"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          ) : (
            !loadingMenuUsers && (
              <Typography
                variant="body1"
                color="textSecondary"
                align="center"
                sx={{
                  fontStyle: "italic",
                  color: "#777",
                  fontSize: "1rem",
                  padding: "20px",
                  border: "1px solid #eee",
                  borderRadius: "4px",
                  backgroundColor: "#f9f9f9",
                  marginTop: "10px",
                }}
              >
                No users are currently associated with this menu.
              </Typography>
            )
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "16px", gap: 2 }}>
          <Button
            variant="contained"
            onClick={handleCloseUserAccessDialog}
            color="primary"
            size="small"
            sx={{
              fontSize: 14,
              textTransform: "capitalize",
              height: 40,
              borderRadius: 1,
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MenuManagement;
